<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<form [formGroup]="form">
					<div class="permission-container" [hidden]="true">
						<div class="radio-label">Permission Level</div>
						<mat-radio-group formControlName="permissionLevel">
							<mat-radio-button [tooltip]="customTooltip" placement="bottom" [value]="permissionLevel.custom"
								>{{ permissionLevel.custom }}
							</mat-radio-button>
						</mat-radio-group>
					</div>

					<ng-template #reOnboardBlock>
						<div class="account-selects-container">
							<div class="description">
								Set up <strong>Cost and Usage Reports</strong> on your AWS master payer account
							</div>
							<div class="step-card__content mb-2">
								<div class="mb-1">Are you connecting your root account?</div>
								<mat-radio-group formControlName="curSelect" aria-labelledby="radio-group-label">
									<mat-radio-button class="mr-2 block" [value]="curSelectOptions.notMaster"
										>No, it`s a sub-account</mat-radio-button
									>
									<!-- <mat-radio-button class="mr-2 block" [value]="curSelectOptions.yesCreate"
										>Yes, it`s the master-payer</mat-radio-button
									> -->
									<mat-radio-button class="mr-2 block" [value]="curSelectOptions.yesEnabled"
										>Yes. The report is already enabled</mat-radio-button
									>
								</mat-radio-group>

								<div class="row">
									<div class="col-5 mt-22p">
										<mat-form-field appearance="outline">
											<mat-label>Region</mat-label>
											<mat-select formControlName="region">
												<mat-option *ngFor="let region of availableRegions" [value]="region.code">
													{{ region.name }} ({{ region.code }})
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-7">
										<div *ngIf="curRadio.value !== curSelectOptions.notMaster">
											<div>Enter the <strong>bucket name</strong> where the report is located</div>
											<mat-form-field appearance="outline" class="cur-input">
												<mat-label>Bucket name:</mat-label>
												<input formControlName="curBucketName" matInput placeholder="Bucket name" />
											</mat-form-field>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>

					<div class="custom-permissions">
						<mat-horizontal-stepper (selectionChange)="stepChanged($event)">
							<mat-step>
								<ng-template matStepLabel>Pick permissions</ng-template>
								<app-onboarding-permissions-tree
									[partnersMode]="true"
									[partnersAccountId]="data.options.row['id']"
									(emitPermissions)="collectPermissions($event)"
									[submitSubject]="permissionsSubject$"
								></app-onboarding-permissions-tree>
								<div class="text-right">
									<button
										class="step-btn"
										[disabled]="isLoading$ | async"
										(click)="permissionsSubject$.next(true)"
										mat-button
										matStepperNext
									>
										Next
										<mat-icon class="mat-icon-rtl-mirror">chevron_right</mat-icon>
									</button>
								</div>
							</mat-step>
							<mat-step>
								<ng-template matStepLabel>Cost and Usage Reports</ng-template>
								<ng-container [ngTemplateOutlet]="reOnboardBlock"></ng-container>
								<div class="text-left">
									<button class="step-btn" [disabled]="isLoading$ | async" mat-button matStepperPrevious>
										<mat-icon class="mat-icon-rtl-mirror">chevron_left</mat-icon>
										Back
									</button>
								</div>
							</mat-step>
						</mat-horizontal-stepper>
					</div>
				</form>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button
					class="zesty-modal__create-btn"
					(click)="generateLinks()"
					[disabled]="form.invalid || (permission.value === permissionLevel.custom && selectedStep !== 1)"
				>
					Generate
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #customTooltip>
	<div class="p-1 text-left">Select permission manually</div>
</ng-template>
